// Ejecuta la búsqueda de jugadas de la IA en un Web Worker (no bloquea la interfaz).
// Si el worker no está disponible (o falla), recurre a una búsqueda síncrona.
import { findBestWord as syncFindBestWord } from '../game/aiSearch.js';

export class AIRunner {
  constructor() {
    this.worker = null;
    this._failed = false;
    this._seq = 0;
    this._pending = new Map();
    this._sentDict = null; // referencia del diccionario ya enviado al worker
  }

  _ensure() {
    if (this.worker || this._failed) return;
    try {
      this.worker = new Worker(new URL('../workers/ai-worker.js', import.meta.url), { type: 'module' });
      this.worker.onmessage = (e) => {
        const { id, ok, best } = e.data;
        const p = this._pending.get(id);
        if (p) {
          this._pending.delete(id);
          clearTimeout(p.timer);
          p.resolve(ok ? best : null);
        }
      };
      this.worker.onerror = () => { this._failed = true; };
    } catch {
      this._failed = true;
    }
  }

  /**
   * Busca la mejor palabra. Devuelve una promesa (worker) o el resultado síncrono de reserva.
   * @returns {Promise<{word,tiles,score}|null>}
   */
  findBestWord(rack, dictionary, opts) {
    this._ensure();
    if (!this.worker || this._failed) {
      return Promise.resolve(syncFindBestWord({ rack, dictionary, opts }));
    }
    const id = ++this._seq;
    // El diccionario se envía cuando CAMBIA (el worker lo cachea). Distintos niveles usan
    // distintos diccionarios (semilla vs completo): reenviar si la referencia difiere.
    const payload = { id, rack, opts };
    if (this._sentDict !== dictionary) { payload.dictionary = dictionary; this._sentDict = dictionary; }

    return new Promise((resolve) => {
      const timer = setTimeout(() => {
        if (this._pending.has(id)) {
          this._pending.delete(id);
          // Reserva síncrona si el worker tarda demasiado.
          resolve(syncFindBestWord({ rack, dictionary, opts }));
        }
      }, 4000);
      this._pending.set(id, { resolve, timer });
      this.worker.postMessage(payload);
    });
  }

  dispose() {
    this.worker?.terminate();
    this.worker = null;
    for (const p of this._pending.values()) clearTimeout(p.timer);
    this._pending.clear();
  }
}
